<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.doorpassrecord_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/v4ward/door/passrecord/doorpassrecord';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        align: 'center',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 4,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        selection: false,
        menu: false,
        columnBtn: false,
        dialogClickModal: false,
        column: [
          {
            label: '小区',
            prop: 'communityId',
            dataType: 'string',
            type: 'tree',
            hide: true,
            search: true,
            searchSpan: 5,
            dicUrl: '/api/door/setting/getCommunityList',
            props: {
              label: 'communityName',
              value: 'communityId',
            },
            rules: [
              {
                required: true,
                message: '请输入选择小区',
                trigger: 'change',
              },
            ],
          },
          {
            label: '小区名称',
            prop: 'communityName',
            searchSpan: 5,
          },
          {
            label: '人员姓名',
            search: true,
            searchSpan: 4,
            prop: 'personName',
          },
          {
            label: '设备名称',
            prop: 'deviceName',
            searchSpan: 4,
            search: true,
          },
          {
            label: '通行时间',
            prop: 'crossTimeRange',
            search: true,
            hide: true,
            display: false,
            searchSpan: 7,
            searchRange: true,
            type: 'datetimerange',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '通行时间',
            prop: 'crossTime',
          },
          {
            label: '记录类型',
            prop: 'recordType',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=record_type',
            props: { label: 'dictValue', value: 'dictKey' },
            dataType: 'number',
          },
          {
            label: '事件类型',
            prop: 'eventType',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=event_type',
            props: { label: 'dictValue', value: 'dictKey' },
            dataType: 'number',
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.doorpassrecord_add, false),
        viewBtn: this.vaildData(this.permission.doorpassrecord_view, false),
        delBtn: this.vaildData(this.permission.doorpassrecord_delete, false),
        editBtn: this.vaildData(this.permission.doorpassrecord_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      if (this.query.crossTimeRange) {
        this.query.crossTimeStar = this.query.crossTimeRange[0];
        this.query.crossTimeEnd = this.query.crossTimeRange[1];
      }
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
